import { Fragment } from "react";
import BarChartBox from "components/BarChartBox";
import getModuleName from "utils/getModuleName";
import { udCompareEditionApiIndexOrder } from "utils/udCompareEditionOrder";

export default function ChartsSection({ charts, mainHeading, series_colors, allowed_colors, visualization_options, territory_polska, key_variable_tooltip, isCompareMode, edition1, edition2, onColorChange, loading = false }) {

   const module = getModuleName();
   const azzkuLike = module === "AZZKU" || module === "AZZKU_TOP";

   const azzkuHeadingPrefix = azzkuLike && mainHeading
      ? (() => {
         const parts = mainHeading.split("|").map(p => p.trim()).filter(Boolean);
         parts.pop();
         return parts.join(" | ");
      })()
      : "";

   // Komunikat tylko po zakończeniu ładowania i faktycznie pustej odpowiedzi (tablica charts).
   // Gdy charts jest null/undefined (jeszcze nie pobrano danych albo warunek zapytania nieaktywny) — nic nie pokazuj.
   if (!loading && Array.isArray(charts) && charts.length === 0) {
      return (
         <div className="no-data-message">
            <div className="no-data-icon">📊</div>
            <h4>Brak danych</h4>
            <p>Dla wybranych kryteriów nie ma dostępnych danych do wyświetlenia.</p>
         </div>
      );
   }

   return (
      <>
         {Array.isArray(charts) && !!charts?.length &&
            charts.map((chart, i) => {

               let data = [];
               let legend = [];

               if ( module === "AZZKU" ) {
                  legend = chart.series?.map(s => s.name);
                  data = chart.categories?.map((cat, i) => ({
                     label: cat,
                     average: undefined,
                     ...(chart.series?.reduce((res, current, j) => {
                        const value = current.data[i];
                        // Dla wartości null ustawiamy 0, ale z flagą null, żeby Recharts renderował kolumnę
                        // Funkcja shape sprawdzi flagę i wyświetli "Brak danych"
                        res["data-item" + j] = value === null ? 0 : (value || 0);
                        res["data-item" + j + "-null"] = value === null;
                        return res;
                     }, {}))
                  }))

               } else {
                  const editionLabels =
                     isCompareMode && edition1 && edition2 ? [edition1, edition2] : null;
                  const compareApiOrder =
                     editionLabels && editionLabels.length === 2
                        ? udCompareEditionApiIndexOrder(edition1, edition2)
                        : null;

                  // W trybie porównania: legenda i słupki w kolejności chronologicznej (nie kolejności wyboru)
                  if (editionLabels) {
                     legend = compareApiOrder.map((i) => editionLabels[i]);
                  } else {
                     legend = chart.legend;
                  }
                  data = (chart.columns || []).map( c => {
                     const result = {
                        label: c.label,
                        average: c.average_percentage,
                        average_raw: c.average, // Surowa wartość średniej (nie procentowa)
                        value_as_percent: true
                     };
                     
                     // Obsługa count i percentage - mogą być tablicami liczb lub stringów
                     if (c.count && Array.isArray(c.count)) {
                        const mapCompareRow = (srcIdx, destIdx) => {
                           const current = c.count[srcIdx];
                           let countValue = current;
                           if (isCompareMode && typeof countValue === 'string' && countValue.includes('(')) {
                              const match = countValue.match(/^(\d+)/);
                              if (match) countValue = match[1];
                           }
                           const percentageValue =
                              c.percentage && Array.isArray(c.percentage) && c.percentage[srcIdx] !== undefined
                                 ? c.percentage[srcIdx]
                                 : typeof current === 'number'
                                    ? current
                                    : 0;
                           result["data-item" + destIdx] = percentageValue;
                           result["data-item" + destIdx + "-extra"] = countValue;
                           result["data-item" + destIdx + "-null"] =
                              current === null || current === undefined;
                        };

                        if (isCompareMode && compareApiOrder && c.count.length >= 2) {
                           compareApiOrder.forEach((srcIdx, destIdx) => mapCompareRow(srcIdx, destIdx));
                        } else {
                           c.count.forEach((current, i) => mapCompareRow(i, i));
                        }
                     }
                     
                     return result;
                  });
                }
 
                return (
                  <Fragment key={i}>
                     <BarChartBox
                        {...visualization_options}
                        heading={territory_polska ? 'Polska' : (chart.title || chart.label || chart.voivodeship_name)}
                        captureHeading={azzkuLike && azzkuHeadingPrefix
                           ? `${azzkuHeadingPrefix} | ${territory_polska ? 'Polska' : (chart.title || chart.label || chart.voivodeship_name)}`
                           : undefined}
                        legend={legend}
                        series_colors={series_colors}
                        allowed_colors={allowed_colors}
                        data={data}
                        bars_amount={legend?.length || 1}
                        value_is_percent={ module === "UD" }
                        key_variable_tooltip={ key_variable_tooltip }
                        onColorChange={ onColorChange }
                     />

                     <div className="divider" />
                  </Fragment>
               );
            })
         }
      </>
   )
}